$.ready(function() {

	game.addPays = function() {
		var response = game.last;
		if (response.lines && response.lines.win) {
			if (response.lines.pays && response.lines.pays.length) {
				response.lines.pays.sort(function (a, b) {
					if (a[1] === b[1] && a[2] === b[2]) {
						return a[0] > b[0] ? 1 : -1;
					}
					
					else if (a[2] === b[2]) {
						return a[1] < b[1] ? 1 : -1;
					}
					
					else {
						return a[2] < b[2] ? 1 : -1;
					}
				});
				
				for (pay in response.lines.pays) {
					pay = response.lines.pays[pay];
					
					pay[3] = [];
					
					for (reel = 0; reel < pay[1]; reel++) {
						row = game.pays.lines[pay[0]][reel];
						
						pay[3].push([ reel, row ]);
					}
				}
				
				for (pay in response.lines.pays) {
					game.pays.add('line', response.lines.pays[pay]);
				}
			}
		}
		
		for (reel in game.frame.reels) {
			for (row in game.frame.reels[reel].symbols) {
				if (response.animate[reel][row] || (response.sticky && response.sticky[reel][row])) {
					source = game.spindle.reels[reel].window.symbols[row];
					target = game.frame.reels[reel].symbols[row];
					
					if (response.sticky && response.sticky[reel][row]) {
						target.attr('class', 'symbol symbol-0');
					}
					
					else {
						target.attr('class', source.attr('class'));
					}
					
					source.addClass('hide');
				}
			}
		}
	};
	
});


/** WEBPACK FOOTER **
 ** ./public-src/js/addPays.js
 **/